import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ScoreInfo } from './Atoms';

type ExerciseTitleBarScoreInfoProps = {
  userLastScore?: string;
  groupAverageScore?: string;
};

export const ExerciseTitleBarScoreInfo: FC<ExerciseTitleBarScoreInfoProps> = ({
  userLastScore,
  groupAverageScore,
}) => {
  const { t } = useTranslation();

  if (userLastScore == null && groupAverageScore == null) return null;

  return (
    <ScoreInfo>
      {userLastScore != null ? (
        <>
          {userLastScore === ''
            ? t('progressAndScores.exercise.emptyScore')
            : `${t('progressAndScores.exercise.lastScore')}: ${userLastScore}`}
        </>
      ) : (
        <>
          {groupAverageScore != null && (
            <>{`${t('progressAndScores.exercise.averageScore')}: ${groupAverageScore}`}</>
          )}
        </>
      )}
    </ScoreInfo>
  );
};
